import { render, staticRenderFns } from "./SubmitClaimDashboardItemSba.vue?vue&type=template&id=84922510&scoped=true"
import script from "./SubmitClaimDashboardItemSba.vue?vue&type=script&lang=js"
export * from "./SubmitClaimDashboardItemSba.vue?vue&type=script&lang=js"
import style0 from "./SubmitClaimDashboardItemSba.vue?vue&type=style&index=0&id=84922510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84922510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardText,VCol,VIcon})
